<template>
  <div class="flash-message">
    <transition name="slide">
      <div
        v-show="isShow && type === 'toast'"
        class="toast-message"
        :style="{'backgroundColor': color, 'top': top}"
      >
        {{ message }}
        <a
          v-if="!isDisableClose"
          class="toast-message__close"
          :style="{'background-image': `url(${iconClose})`}"
          @click="closeDialog()"
        />
      </div>
    </transition>
    <transition name="fade">
      <div
        v-show="isShow && type === 'default'"
        id="spice-dialog-8"
        class="dialog-opacity add-shopbag-tip"
        style="z-index: 9999;"
      >
        <div class="dialog-scroll-wrap">
          <div
            class="dialog-scroll-container"
            @click="closeDialog()"
          >
            <div class="dialog-scroll">
              <div>
                <div class="dialog">
                  <div class="dialog-container">
                    <div class="dialog-content">
                      <div>
                        <p>
                          {{
                            message
                          }}
                          <i
                            v-if="type==='success'"
                            class="icon icon-pdp-log-ok"
                          />
                        </p>
                      </div>
                    </div>
                  </div>
                  <i class="icon icon-close dialog-close">×</i>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
export default {
  name: 'FlashMessage',
  computed: {
    isShow() {
      return this.$store.state.flashMessage.isShow;
    },
    isDisableClose() {
      return this.$store.state.flashMessage.isDisableClose;
    },
    isAuto() {
      const { isAuto } = this.$store.state.flashMessage;
      return isAuto;
    },
    color() {
      const { action } = this.$store.state.flashMessage;
      /* available action : 'success' , 'failed' */
      if (action === 'failed') {
        return '#C10230';
      }
      return '#53B25C';
    },
    type() {
      const { type } = this.$store.state.flashMessage;
      return type;
    },
    top() {
      const { top } = this.$store.state.flashMessage;
      return top;
    },
    message() {
      return this.$store.state.flashMessage.message;
    },
    iconClose() {
      return `${process.env.VUE_APP_BASE_RESOURCE}/resources/v2/images/svg/close-white.svg`;
    },
  },
  watch: {
    isShow(newValue) {
      if (newValue === true && this.isAuto === true) {
        this.initFlashMessage();
      }
    },
  },
  methods: {
    closeDialog() {
      this.$store.dispatch('flashMessage/closeFlashMessage');
    },
    initFlashMessage() {
      let timer;
      window.clearTimeout(timer);
      timer = setTimeout(() => {
        this.closeDialog();
        clearTimeout(timer);
      }, 3000);
    },
  },
};
</script>

<style lang="scss" scoped>
.dialog-opacity {
  transition: opacity 2s ease-in-out;
}

.dialog-opacity {
  background-color: rgba(0, 0, 0, 0.6);
  position: fixed;
  width: 100%;
  height: 100%;
  left: 0;
  top: 0;
  z-index: 20;
  overflow-x: hidden;
  overflow-y: auto;
  min-width: 320px;
}
.dialog-opacity .dialog-scroll-wrap {
  display: table;
  width: 100%;
  height: 100%;
}
.dialog-opacity .dialog-scroll-container {
  width: 100%;
  height: 100%;
  text-align: center;
  position: relative;
  display: table-cell;
  vertical-align: middle;
}
.dialog-opacity .dialog-scroll-container .dialog-scroll {
  *position: absolute;
  *top: 50%;
  *left: 50%;
  display: inline-block;
}
.dialog-opacity .dialog-scroll-container .dialog-scroll > div {
  *top: -50%;
  *left: -50%;
  position: relative;
}
.dialog-opacity .dialog-scroll-container .dialog {
  background-color: transparent;
  left: auto;
  position: relative;
  top: auto;
  vertical-align: middle;
  max-width: 500px;
  width: auto;
  margin: 80px 20px;
  padding: 0;
  border-radius: 0;
}
.dialog-opacity .dialog-scroll-container .dialog-container {
  background-color: #fff;
  text-align: left;
  display: block;
  width: auto;
  height: auto;
  padding: 40px;
  border-radius: 4px;
}
.dialog-opacity-transparent {
  background-color: transparent;
}
.add-shopbag-tip .dialog-scroll-container .dialog-container {
  padding: 0;
  background-color: rgba(0, 0, 0, 0.7);
}
.add-shopbag-tip .dialog-content > div {
  padding: 47px 48px;
}
.add-shopbag-tip .dialog-content > div p {
  font-size: 14px;
  color: #fff;
  position: relative;
}
.add-shopbag-tip .dialog-content > div p i {
  position: absolute;
  top: 0;
  right: -25px;
}
.add-shopbag-tip .dialog-close {
  display: none;
}

.fade-enter-active, .fade-leave-active {
  transition: opacity .5s;
}

.fade-enter, .fade-leave-to {
  opacity: 0;
}

</style>

<style lang="scss" scoped>
.toast-message {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 16px;
  transition: all .3s ease;
  color: $white;
  font-size: 14px;
  padding: 10px 16px;
  line-height: 19px;
  position: fixed;
  top: 20%;
  left: 50%;
  transform: translateX(-50%);
  z-index: 999;

  &__close {
    background-repeat: no-repeat;
    width: 24px;
    height: 24px;
    position: absolute;
    right: 16px;
    top: 50%;
    transform: translateY(-50%);
  }
}

.slide-enter,
.slide-leave-to {
  opacity: 0;
  transform: translate(-50%, -60px);
}

@media (max-width:1024px) {
  .toast-message {
    top: 10%;
    transform: unset;
    left: 0;
    right: 0;
    margin: 0 auto;
    width: fit-content;
    max-width: 90%;
  }
}
</style>
